var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLargeSuccess = function SvgLargeSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.0902856
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0001 2.72205C111.927 2.72205 143.533 34.328 143.533 73.2553C143.533 112.183 111.927 143.789 73.0001 143.789C34.0728 143.789 2.4668 112.183 2.4668 73.2553C2.4668 34.328 34.0728 2.72205 73.0001 2.72205Z",
    fill: "#6A8EFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0001 2.72205C111.927 2.72205 143.533 34.328 143.533 73.2553C143.533 112.183 111.927 143.789 73.0001 143.789C34.0728 143.789 2.4668 112.183 2.4668 73.2553C2.4668 34.328 34.0728 2.72205 73.0001 2.72205Z",
    stroke: "#6A8EFE",
    strokeWidth: 4.05355
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 21.5202C101.81 21.5202 125.201 44.9116 125.201 73.7214C125.201 102.531 101.81 125.923 73 125.923C44.1902 125.923 20.7988 102.531 20.7988 73.7214C20.7988 44.9116 44.1902 21.5202 73 21.5202Z",
    fill: "#4572FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6052 55.8372C99.3612 57.5359 99.4075 60.3366 97.7087 62.0925L67.0369 93.7966C66.2175 94.6436 65.094 95.1286 63.9157 95.1441C62.7374 95.1597 61.6015 94.7044 60.7601 93.8793L45.5716 78.9858C43.8272 77.2752 43.7997 74.4743 45.5103 72.7299C47.2209 70.9854 50.0218 70.9579 51.7662 72.6685L63.7747 84.4438L91.3498 55.9407C93.0486 54.1847 95.8493 54.1384 97.6052 55.8372Z",
    fill: "white"
  })));
};
export default SvgLargeSuccess;